// Imports Angular
import { Compiler } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Logger } from 'angular2-logger/core';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { SessionStorageService } from 'ngx-webstorage';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Imports DIAN
import { DContextoMuiscaServicio, DContextoMuiscaDesaServicio, DLogger, DLoggerAngular, DSessionStorage } from '@dian/core';
import { DFormularioServicio} from '@dian/api-formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DValidacionesFormularioServicio, DOperacionesMatematicasServicio, DInterfaceConfiguracionFormulario, DAyudasFormularioServicio, DInterfaceAyudaFormulario } from '@dian-cmp/formulario';
import { environment } from './../../environments/environment'; 


const is_desa = false;

export function loggerFactory (logger:Logger, sessionStorage:SessionStorageService) {
    return new DLoggerAngular(logger, sessionStorage);     
}

export function sessionStorageFactory(sessionStorage:SessionStorageService,logger:DLogger) {
	return new DSessionStorage(sessionStorage,logger);    
}

export function contextoMuiscaFactory (http:Http, cookieService:CookieService, compiler:Compiler, logger:DLogger, dNotificacionServicio:DNotificacionServicio, sessionStorage:DSessionStorage) {
    if (is_desa) {                   
        return new DContextoMuiscaDesaServicio(http, cookieService, compiler, logger, dNotificacionServicio, sessionStorage,false, environment);                   
    } else {
        return new DContextoMuiscaServicio(http, cookieService, compiler, logger, dNotificacionServicio, sessionStorage,false, environment);
    }
}


export function formularioFactory(contextoServicio:DContextoMuiscaServicio) {
    return new DFormularioServicio(contextoServicio);    
}

//Factory para cargar la directiva que realiza las validaciones de los formularios
export function validacionesFormularioFactory (configuracion: DInterfaceConfiguracionFormulario, dutilidades:DOperacionesMatematicasServicio) {
	return new DValidacionesFormularioServicio(configuracion, dutilidades);
}

//Factory para cargar la directiva que muestra las ayudas en el formulario
export function ayudasFormularioFactory (ayudas: DInterfaceAyudaFormulario) {
	return new DAyudasFormularioServicio(ayudas);
}

//Traductor
export function HttpLoaderTranslatorFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}



// WEBPACK FOOTER //
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/configuracion/app.factories.ts